var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z",
    fill: "#0082CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0809 14.15C11.2909 12.29 6.74094 12.29 3.93094 14.15C2.66094 15 1.96094 16.15 1.96094 17.38C1.96094 18.61 2.66094 19.75 3.92094 20.59C5.32094 21.53 7.16094 22 9.00094 22C10.8409 22 12.6809 21.53 14.0809 20.59C15.3409 19.74 16.0409 18.6 16.0409 17.36C16.0309 16.13 15.3409 14.99 14.0809 14.15Z",
    fill: "#0082CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9894 7.33998C20.1494 9.27998 18.7694 10.98 16.8594 11.21C16.8494 11.21 16.8494 11.21 16.8394 11.21H16.8094C16.7494 11.21 16.6894 11.21 16.6394 11.23C15.6694 11.28 14.7794 10.97 14.1094 10.4C15.1394 9.47998 15.7294 8.09998 15.6094 6.59998C15.5394 5.78998 15.2594 5.04998 14.8394 4.41998C15.2194 4.22998 15.6594 4.10998 16.1094 4.06998C18.0694 3.89998 19.8194 5.35998 19.9894 7.33998Z",
    fill: "#0082CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9902 16.59C21.9102 17.56 21.2902 18.4 20.2502 18.97C19.2502 19.52 17.9902 19.78 16.7402 19.75C17.4602 19.1 17.8802 18.29 17.9602 17.43C18.0602 16.19 17.4702 15 16.2902 14.05C15.6202 13.52 14.8402 13.1 13.9902 12.79C16.2002 12.15 18.9802 12.58 20.6902 13.96C21.6102 14.7 22.0802 15.63 21.9902 16.59Z",
    fill: "#0082CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.676c8c3296ec60ae5be98779bf66faf0.svg";
export { ForwardRef as ReactComponent };